const resultAbstractParts = {
	A1: 'woman',
	A2: 'man',
	A3: '',
	B1: 'rainy',
	B2: 'mountainous',
	B3: 'dry',
	B4: 'tropical',
	B5: 'temperate',
	B6: 'sunny',
	B7: 'urban',
	C1: 'polluted',
	C2: 'unpolluted',
	E1: 'face',
	E2: 'body',
	E3: 'hands & feet',
	E4: 'hair'
}

export default {
	localeName: '日本語',
	mailForm: {
		heading:
			'美への好奇心と飽くなき探究心を満たす〈オフィシーヌ・ユニヴェルセル・ビュリー〉から、適切な情報をご提供するために、ご連絡先の入力をお願いいたします。',
		firstNamePlaceholder: 'お名前',
		emailPlaceholder: 'メールアドレス',
		submissionSuccess: 'ご購読が確認されました。メールをご確認ください。',
		submissionFail: 'エラーが発生しました。後でもう一度お試しください。',
		confirm: '確認',
		skip: 'スキップ',
		loading: '送信中...',
		privacyPolicy: 'プライバシーポリシー',
		privacyPolicyUrl: 'https://buly1803.jp/pages/privacy-policy',
		consent: {
			privacy: 'プライバシーポリシー を読み、これに同意します。',
			diagnosis:
				'プライバシーポリシーに同意の上、スキンコンシェルジュの診断結果をEメールで受信することを希望します。',
			marketing:
				'プライバシーポリシーに同意の上、〈オフィシーヌ・ユニヴェルセル・ビュリー〉からのメールを受け取ります。'
		}
	},
	resultForm: {
		confirm: '確認'
	},
	result: {
		title: 'オフィシーヌ・ユニヴェルセル・ビュリーのおすすめ',
		cta: '鏡よ鏡、私の診断結果は？',
		button: '結果を見る',
		concern: '気になること',
		select: '選択する',
		unselect: '選択中',
		product: 'カートへ入れる',
		addCart: '買い物カゴに追加する',
		newSearch: '新しくスタートする',
		question: 'ご質問ですか？',
		recommend: 'お友達へのおすすめ',
		shops: 'ブティック',
		discover: 'Discover',
		skip: 'スキップ',
		showMore: 'もっと見る',
		tip: 'オフィシーヌ・ユニヴェルセル・ビュリーの適切なアドバイス',
		endTitle: 'The officine collection of plant oil'
	},
	loading: 'Loading',
	questions: {
		extra: {
			id: 'extra',
			bulyImage: '/img/portraits/portrait-skin.jpg',
			title: 'あなたの肌ニュアンスは？ ',
			analyticSlug: '0-what-is-your-skin-tone'
		}
	},
	diagnosis: {
		onTheWay: '診断しています',
		skip: 'スキップ'
	},
	care_tag: {
		Care_Morning: '朝の お手入れ',
		Care_Regular: '定期的な お手入れ',
		Care_Occasional: 'スペシャル ケア',
		Care_Evening: ' 夜の お手入れ',
		Care_Daily: '毎日の お手入れ',
		Care_Morning_Evening: '朝晩のお手入れ'
	},
	store: 'https://buly1803.jp/?concierge=',
	klaviyoId: 'YhQquR',
	resultAbstract: ctx =>
		`You are a ${resultAbstractParts[ctx.named('gender')]} who lives in a ${
			resultAbstractParts[ctx.named('climate1')]
		} ${
			resultAbstractParts[ctx.named('climate2')]
		} environment, concerned about your ${
			resultAbstractParts[ctx.named('concern')]
		}`
}
